module.exports = __webpack_public_path__ + "img/crossdock-logo.72bfee74.png";